import React, { useState } from 'react';
import { useModal } from '../../context/ModalContext';
import './DocumentsSection.css';

const documents = [
  {
    icon: '📄',
    title: 'X & XII Marksheet',
    desc: 'Certified copies of both Class 10th and 12th mark sheets from your recognised board.',
    color: 'blue',
  },
  {
    icon: '🧪',
    title: 'NEET Score Card',
    desc: 'Official NEET-UG score card issued by NTA — mandatory for all MBBS abroad applications.',
    color: 'green',
  },
  {
    icon: '🪪',
    title: 'Birth Certificate',
    desc: 'Government-issued birth certificate to verify your date of birth and nationality.',
    color: 'orange',
  },
  {
    icon: '🏦',
    title: 'Bank Statement',
    desc: 'Last 6-month bank statement showing sufficient funds for tuition and living expenses.',
    color: 'purple',
  },
  {
    icon: '🛂',
    title: 'Valid Travel Document',
    desc: 'A valid Indian Travel Document with at least 18 months validity from the date of admission.',
    color: 'sky',
  },
  {
    icon: '📸',
    title: 'Photos',
    desc: 'Recent Photo (white background) as per university requirements.',
    color: 'pink',
  },
  {
    icon: '💉',
    title: 'Medical Certificate',
    desc: 'Fitness certificate from a registered medical practitioner confirming you are healthy.',
    color: 'teal',
  },
  {
    icon: '🌐',
    title: 'Transfer Certificate',
    desc: 'TC issued by your last attended school or college, required for university enrolment.',
    color: 'gold',
  },
];

const tips = [
  '📁 Organise all documents in a folder with multiple photocopies of each.',
  '✅ Get all documents notarised and attested by the relevant authorities.',
  '🌍 Requirements vary by country — our counsellors will guide you specifically.',
  '⏰ Start collecting documents early — some take 4–8 weeks to process.',
];

const DocumentsSection = () => {
  const { openModal } = useModal();
  const [activeDoc, setActiveDoc] = useState(null);

  return (
    <section className="docs-section" id="documents">
      <div className="docs-inner">

        {/* ── Two column layout ── */}
        <div className="docs-layout">

          {/* Left: Image + tips */}
          <div className="docs-left reveal">
            <div className="docs-img-wrap">
              <div className="docs-img-bg" />
              <div className="docs-img-content">
                <div className="docs-img-badge">📋 Checklist</div>
                <div className="docs-img-stat">
                  <span className="docs-stat-num">8</span>
                  <span className="docs-stat-txt">Essential Documents</span>
                </div>
                <div className="docs-img-note">✅ Our counsellors verify every document</div>
              </div>
            </div>

            {/* Tips */}
            <div className="docs-tips">
              <div className="docs-tips-title">💡 Pro Tips</div>
              {tips.map((tip, i) => (
                <div className="docs-tip" key={i}>{tip}</div>
              ))}
            </div>
          </div>

          {/* Right: Content + grid */}
          <div className="docs-right reveal">
            <div className="sec-label">Document Checklist</div>
            <h2 className="sec-title docs-title">
              Documents Required to Study<br />
              <span className="docs-grad">MBBS Abroad</span>
            </h2>
            <p className="sec-sub docs-sub">
              To ensure a smooth transition from the application process to university registration,
              all Indian medical aspirants must carry and keep all required documents organised in a folder
              with multiple photocopies of each. The exact documents vary depending on the university and
              the country's jurisdiction.
            </p>

            {/* Documents grid */}
            <div className="docs-grid">
              {documents.map((doc, i) => (
                <div
                  key={i}
                  className={`doc-card doc-card--${doc.color} ${activeDoc === i ? 'doc-card--active' : ''}`}
                  onClick={() => setActiveDoc(activeDoc === i ? null : i)}
                >
                  <div className="doc-card-icon">{doc.icon}</div>
                  <div className="doc-card-body">
                    <div className="doc-card-title">{doc.title}</div>
                    <div className={`doc-card-desc ${activeDoc === i ? 'visible' : ''}`}>
                      {doc.desc}
                    </div>
                  </div>
                  <div className="doc-card-check">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <circle cx="7" cy="7" r="6.5" stroke="currentColor" strokeWidth="1.2"/>
                      <path d="M4.5 7l1.8 1.8 3.2-3.6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="docs-cta">
              <button onClick={openModal} className="docs-cta-btn">
                Get Document Assistance Free →
              </button>
              <span className="docs-cta-note">Expert guidance · No charges · 24-hr support</span>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default DocumentsSection;